const KEY = "edi-sid";

export function getSid() {
    try {
        let sid = sessionStorage.getItem(KEY);
        if (!sid) {
            sid = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`);
            sessionStorage.setItem(KEY, sid);
        }
        return sid;
    } catch {
        return null;
    }
}

export function routeName(pathname, search) {
    const path = pathname.replace(/\/(?:[0-9a-f]{8}-[0-9a-f-]{27,}|\d+)(?=\/|$)/gi, "/:id");
    const p = new URLSearchParams(search);
    const key = ["tab", "vista"].find((k) => p.get(k));
    return key ? `${path}?${key}=${p.get(key)}` : path;
}

export function sendPageView(route) {
    const send = () => {
        try {
            fetch(`${process.env.REACT_APP_BACKEND_URL}/api/nav`, {
                method: "POST", keepalive: true, credentials: "include",
                headers: { "Content-Type": "application/json", "X-Edi-Sid": getSid() || "" },
                body: JSON.stringify({ t: "pagina_vista", r: route }),
            }).catch(() => {});
        } catch {
            /* recording must never affect the user */
        }
    };
    (window.requestIdleCallback || ((cb) => setTimeout(cb, 0)))(send);
}
